import { render, staticRenderFns } from "./Mailinglists.vue?vue&type=template&id=262513d7&"
import script from "./Mailinglists.vue?vue&type=script&lang=js&"
export * from "./Mailinglists.vue?vue&type=script&lang=js&"
import style0 from "./Mailinglists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Mailinglists.vue"
export default component.exports